/** =========================================================
 * Designers controller
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.page-projector-employees')
    .controller('ProjectorEmployeesController', ProjectorEmployeesController);

  ProjectorEmployeesController.$inject = ['$rootScope', '$scope', '$api', '$state', '$stateParams', '$translate', 'ngDialog'];

  function ProjectorEmployeesController($rootScope, $scope, $api, $state, $stateParams, $translate, ngDialog) {
    var vm = this;

    vm.pageTitle = $state.current.title;
    vm.pageSubTitle = $state.current.subTitle;
    vm.init = false;

    if ($rootScope.appConfig) {
      activate();
    } else {
      var getAppConfig = $rootScope.$watch('appConfig', function (value) {
        if (value) {
          activate();
          getAppConfig();
        }
      });
    }

    // //////////////

    function activate() {
      vm.init = true;

      Raven.captureBreadcrumb({
        message: 'Page projector employees',
        data: {
          filters: $stateParams.filters
        }
      });

      var addCertificate = function (item) {
        try {
          item.projector_employee_certificates.push({
            uid: null,
            issue_date: null,
            name: null
          });
        } catch (error) {
          Raven.captureException(error);
        }
      };

      var removeItem = function (stack, index) {
        try {
          var dialogScope = $scope.$new(true);

          dialogScope.message = 'Do you really want to delete?';

          ngDialog.openConfirm({
            template: 'app/views/dialogs/confirm.html',
            scope: dialogScope
          }).then(function () {
            var item = stack[index];

            if (item.id) {
              item.deleted_at = moment();
            } else {
              stack.splice(index, 1);
            }
          });
        } catch (error) {
          Raven.captureException(error);
        }
      };

      vm.tableConfig = {
        model: 'projector_employee',
        getDataParams: {
          order: {
            id: 'desc'
          },
          with: ['projector_employee_certificates', {
            projectors: ['id', 'name']
          }],
          count: ['project_parts']
        },
        filters: angular.copy($stateParams.filters),
        resources: ['projector'],
        helpers: {
          addCertificate: addCertificate,
          removeItem: removeItem
        },
        fields: [{
          title: 'Name',
          key: 'name',
          order: true
        }, {
          title: 'Certificates',
          key: null,
          value: function (item) {
            return item.projector_employee_certificates.map(function (cert) { return cert.uid; }).join(', ');
          }
        }, {
          title: 'Phone',
          key: 'phone',
          order: true
        }, {
          title: 'Email',
          key: 'email',
          order: true
        }],
        add: {
          template: 'app/views/dialogs/item-projector-employee.html',
          item: $stateParams.filters.length !== 0 ? {
            projectors: [{ id: $stateParams.filters[0].value[0][3], name: $stateParams.filters[0].name }],
            projector_employee_certificates: []
          } : {
            projector_employee_certificates: []
          }
        },
        edit: {
          template: 'app/views/dialogs/item-projector-employee.html',
          except: ['project_parts_count']
        },
        delete: {},
        linkButtons: [{
          title: 'Projectors',
          icon: 'icon-pencil',
          class: 'btn-info mr-1',
          permission: $rootScope.helpers.hasPermissionTo('projector view'),
          action: function (item) {
            try {
              $state.go('app.page-projectors', {
                filters: [{
                  name: $translate.instant('Projector employee') + ': ' + item.name,
                  attr: 'whereHas',
                  value: [
                    ['projector_employees', 'projector_employee_id', '=', item.id]
                  ]
                }]
              });
            } catch (error) {
              Raven.captureException(error);
            }
          },
          text: function (item) {
            try {
              return item.projectors.length;
            } catch (error) {
              Raven.captureException(error);
            }

            return '';
          }
        }, {
          title: 'Project parts',
          icon: 'icon-layers',
          class: 'btn-info mr-1',
          permission: $rootScope.helpers.hasPermissionTo('project_part view'),
          action: function (item) {
            try {
              $state.go('app.page-project-parts', {
                filters: [{
                  name: $translate.instant('Projector employee') + ': ' + item.name,
                  attr: 'where',
                  value: [
                    ['projector_employee_id', '=', item.id]
                  ]
                }]
              });
            } catch (error) {
              Raven.captureException(error);
            }
          },
          text: function (item) {
            try {
              return item.project_parts_count;
            } catch (error) {
              Raven.captureException(error);
            }

            return '';
          }
        }]
      };

      vm.tableConfig.getData = function () {
        try {
          return $rootScope.helpers.defaultGetData(vm.tableConfig);
        } catch (error) {
          Raven.captureException(error);
        }

        return $rootScope.helpers.emptyPromise();
      };

      vm.tableConfig.getData();

      $rootScope.helpers.initActiveTableConfig(vm.tableConfig);
    }
  }
})();
